import { useSWRFetcher } from "./useSWRFetcher";
import { useAuth0 } from "@auth0/auth0-react";
import { environment } from "../config/environment";
import { EmailContextResponse } from "@attelas/shared";
import useSWRMutation from "swr/mutation";

export type EmailAnalysisRequest = {
  emailId: string;
  sender: string;
  subject: string;
  email: string;
  attachments: Office.AttachmentDetails[];
};

export const useAnalyseEmail = () => {
  const fetcher = useSWRFetcher();
  const { user } = useAuth0();

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/emails/analysis/context`,
    (url: string, { arg }: { arg: EmailAnalysisRequest }) =>
      fetcher<EmailContextResponse>(url, {
        method: "POST",
        body: JSON.stringify({
          senderName: user?.name,
          emailId: arg.emailId,
          sender: arg.sender,
          subject: arg.subject,
          email: arg.email,
          attachments: [], //TODO: we cannot get the attachments correctly, maybe we need to use graph api to get the attachments
        }),
      })
  );

  return {
    analyseEmail: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
